import { FC } from "react";
import InputTemp from "components-new/InputTemp";
import { User } from "pages/EmployeePage/EmployeeCard/model";
import styles from "./Form.module.sass";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { ReactComponent as ChangeIcon } from "images/changeConfidence.svg";
import { resetPassword } from "toolkit/profile/profile.thunks";

interface FormPropsInterface {
	disabledForm: boolean;
	state: User;
	changeField: any;
}

const Form: FC<FormPropsInterface> = ({ disabledForm, state, changeField }) => {
	const dispatch = useAppDispatch();

	const admin = useAppSelector((state) => state.profile.profile.admin);

	const reset = () => {
		dispatch(resetPassword(state.email));
	};
	return (
		<form className={styles.form}>
			<InputTemp
				required={true}
				className={styles.input}
				label="Фамилия"
				value={state.lastName}
				name={"lastName"}
				onChange={changeField}
				disabled={disabledForm}
			/>
			<InputTemp
				required={true}
				className={styles.input}
				label="Имя"
				value={state.firstName}
				name={"firstName"}
				onChange={changeField}
				disabled={disabledForm}
			/>
			<InputTemp
				required={true}
				className={styles.input}
				label="Отчество"
				value={state.middleName}
				name={"middleName"}
				onChange={changeField}
				disabled={disabledForm}
			/>
			<InputTemp
				type={"phone"}
				className={styles.input}
				label="Номер телефона"
				onChange={changeField}
				name={"phone"}
				value={state.phone}
				disabled={disabledForm}
			/>
			<InputTemp
				required={true}
				className={styles.input}
				label="Почта"
				value={state.email}
				name={"email"}
				onChange={changeField}
				disabled={disabledForm}
			/>
			{admin && (
				<div className={styles.footer}>
					<button type="button" className={styles.clearPass} onClick={reset}>
						<ChangeIcon />
						Сбросить пароль
					</button>
				</div>
			)}
		</form>
	);
};

export default Form;
